/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
};

const defaultProps = {
    ...commonDefaultProps,
    orientation: 'horizontal',
};

const MoveIcon = React.forwardRef((props, ref) => {
    const classNames = [
        's-move-icon',
        `s-move-icon--${props.orientation}`,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            ref={ref}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
});

MoveIcon.propTypes = propTypes;

MoveIcon.defaultProps = defaultProps;

export default MoveIcon;
